import useServiceFactory from "../serviceFactory";

const apiUrl = `/operaciones/controlPatios`;
const apiUrlOperaciones = `/operaciones/viajes/programacion`;
const apiUrlOrdenesTrabajo = `/taller/mantenimiento/OrdenesTrabajo`;

const useApiPatios = () => {
    const service = useServiceFactory({ uri: process.env.REACT_APP_API_URL });

    return {
        filtrar: async (params) => service.get(`${apiUrl}`, { params }),
        obtener: async (id) => service.get(`${apiUrl}/${id}`, { showLoading: true }),
        nuevoPaseSalida: async (params) => service.post(`${apiUrl}/nuevoPaseSalida`, params),
        acceso: async (params) => service.post(`${apiUrl}/acceso`, params),
        salida: async (params) => service.post(`${apiUrl}/salida`, params),
        actualizar: async (id, params) => service.put(`${apiUrl}/${id}`, params),
        actualizarLlantas: async (id) => service.patch(`${apiUrl}/${id}/actualizaLlantas`),

        unidadAveriasyLLantas: async (unidadId) =>
            service.get(`/operaciones/flotillas/${unidadId}/averiasyLlantas`, {
                showLoading: true,
            }),

        obtenerSalidaPorUnidad: async (unidadId) =>
            service.get(`${apiUrl}/salida/unidad/${unidadId}`, {
                showLoading: true,
            }),

        obtenerSelloFiscal: async (cajaId) =>
            service.get(`${apiUrl}/caja/${cajaId}/ultimaEntrada/selloFiscal`),

        obtenerSelloFiscalExterno: async (cajaId) =>
            service.get(`${apiUrl}/caja/${cajaId}/ultimaEntradaExterno/selloFiscal`),

        eliminarSalidasProgramadas: async (ids) =>
            service.delete(`${apiUrl}/${ids}`),

        cancelarSalidasProgramadas: async (ids, comentarios) =>
            service.patch(`${apiUrl}/${ids}/${comentarios}`),

        obtenerInformacion: async (unidadId) =>
            service.get(`${apiUrl}/obtenerInformacion/unidad/${unidadId}`, {
                showLoading: true,
            }),

        obtenerSolicitudServicio: async (unidadId) =>
            service.get(`${apiUrlOrdenesTrabajo}/solicitud/${unidadId}`, {
                showLoading: true,
            }),
            obtenerOrdenesTrabajoAbiertas: async (unidadId) =>
    service.get(
        `${apiUrlOrdenesTrabajo}/unidad/${unidadId}/abiertas`,
        {
            showLoading: true,
        }
    ),

        guardarFotoAccesorio: async (id, checklistId, params) =>
            service.put(`${apiUrl}/${id}/accesorioGuardarFoto/${checklistId}`, params, {
                showSuccess: false,
            }),

        excel: async (params, esAcceso) => {
            console.log("LLAMANDO API EXCEL", {
                url: `${apiUrl}/excel${esAcceso ? "Accesos" : "Salidas"}`,
                params,
                esAcceso,
            });

            return service.get(
                `${apiUrl}/excel${esAcceso ? "Accesos" : "Salidas"}`,
                {
                    params,
                    showLoading: true,
                    download: true,
                    fileName: esAcceso
                        ? "ControlPatios_Accesos.xlsx"
                        : "ControlPatios_Salidas.xlsx",
                }
            );
        },

        guardarBitacora: async (id, params) =>
            service.put(`${apiUrl}/guardarBitacora/${id}`, params, {
                showSuccess: false,
            }),

        eliminarBitacora: async (id) =>
            service.delete(`${apiUrl}/eliminarBitacora/${id}`),

        obtenerPatios: async (params) =>
            service.get("seguridad/usuarios/patiosUsuarios", { params }),

        validarCajaExterna: async (numeroEconomico, placas, showLoading = false) =>
            service.get(
                `${apiUrlOperaciones}/validaCajaExterna/${numeroEconomico}/${placas}`,
                { showLoading }
            ),
    };
};

export default useApiPatios;